import Container from '@brands/Components/Container/Container';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import { config } from '@brands/config/config';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import useWindowSize from '@brands/hooks/useWindowSize';
import { selectSmileScanCaseId } from '@brands/store/selectors/smileScanCase';
import React, { useMemo } from 'react';
import QRCode from 'react-qr-code';

import styles from './styles.module.scss';

const SmileScanWeb = (): JSX.Element => {
  const screenSize = useWindowSize();
  const roleNavigate = useRoleNavigate();
  const smileScanCaseId = useAppSelector(selectSmileScanCaseId);

  const qrUrl = useMemo(() => {
    if (!smileScanCaseId) return null;
    let prefix = '';
    if (config.iot.prefix === 'develop') prefix = 'dev-';
    else if (config.iot.prefix === 'qa') prefix = 'qa-';
    return `https://selfcheck.toothlens.com/tpscan/done/${prefix}${smileScanCaseId.case_id}`;
  }, [smileScanCaseId]);

  return (
    <Container
      isVisibleOnMobile
      containerStyle={{
        justifyContent: screenSize.width >= 564 ? 'center' : 'start',
        overflow: 'hidden',
      }}
      childrenStyle={{ zIndex: '2', paddingTop: screenSize.width > 768 ? '40px' : '16px' }}
      isSidenavVisible={false}
      isIntakeProcess
    >
      <div className={`fs-unmask ${styles.patientFormContainer} ${styles.uploadImageContainer}`}>
        <PatientIntakeNavigation progress={25} />
        <div className={styles.uploadImageContainerDiv}>
          <div className={styles.uploadImageContainerDivFirst}>
            <div className={styles.uploadImageContainerDivFirstLeft}>
              <span className={styles.uploadImageContainerDivFirstLeftHeader} data-testid="image-upload-header">
                Switch to your phone to complete your SmileScan
              </span>
              <span className={styles.getReady}>To complete your SmileScan, follow these steps:</span>
              <ul className={styles.bolletList}>
                <li>Scan the QR code with your phone's camera</li>
                <li>Or visit your unique URL below using your smartphone</li>
              </ul>
              <span className={styles.final}>
                Once you’ve finished taking your pictures, you can
                <span className={styles.finalLink} onClick={() => roleNavigate('/dashboard')}>
                  {' '}
                  click here{' '}
                </span>
                to return to the dashboard.
              </span>
            </div>
            <div className={styles.uploadImageContainerDivRight}>
              <div className={styles.uploadImageContainerDivFirstRight}>
                <div className={styles.uploadImageContainerDivFirstRightContainer}>
                  <div className="fs-exclude">
                    {qrUrl ? (
                      <QRCode
                        className={styles.qrCodeImage}
                        value={qrUrl}
                        size={200}
                        title="SmileScan QR Code"
                      />
                    ) : (
                      <p>Loading QR Code...</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={styles.uploadImageContainerDivSecond}>
            <div className={`fs-unmask ${styles.uploadImageIntraoralCamera}`}>
              <span>{qrUrl ?? ''}</span>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default React.memo(SmileScanWeb);
